import React from 'react';
import { Text } from '@chakra-ui/react';

export const Subtitle = React.memo(() => {
  return (
    <Text
      mt={3}
      fontSize={{ base: 17, sm: 18, md: 20, lg: 22 }}
      color="orange.700"
      fontWeight="bold"
    >
      以會員價預購
      <Text as="span" color="pink.500">
        德國寶指定人氣家電
      </Text>
      *1件
      <Text as="span" fontSize={{ base: 13, sm: 13, md: 14, lg: 16 }}>
        (包括免費送貨服務#)
      </Text>
      ，更可獲贈
      <Text as="span" color="orange.500">
        額外尊享禮品
      </Text>
      <Text as="span" fontSize={{ base: 13, sm: 13, md: 14, lg: 16 }}>
        (高達價值$100)
      </Text>
      ！
    </Text>
  );
});
